import * as constants from 'loot-core/client/constants';
import { AuthState, SetAuthStateAction } from 'loot-core/client/state-types/auth';

export function setAuthState(state: Partial<AuthState>): SetAuthStateAction {
  return {
    type: constants.SET_AUTH_STATE,
    state,
  };
}
